//src/utils/timeUtils.ts
export const FORMATTING_CHARS_REGEX = /[*_`'~^"]/g;
const MAX_LENGTH = 89;

export const truncateContent = (content: string, maxLength?: number): string => {
    const maxLengthToUse = maxLength ?? MAX_LENGTH;
    // Validate input is a string
    if (typeof content !== 'string') {
        console.warn("truncateContent expected a string but received:", content);
        return '';
    }

    // Trim leading/trailing spaces
    const trimmedContent = content.trim();

    // If content is empty or shorter than/equal to MAX_LENGTH chars, return as-is
    if (trimmedContent.length <= maxLengthToUse) {
        return trimmedContent;
    }

    // Otherwise, truncate to MAX_LENGTH chars and add ellipsis
    return trimmedContent.slice(0, maxLengthToUse) + '...';
};

//currently unused, turncate formatted content. functionality to be used in NotificationUnit.tsx in future version
export const truncateFormattedContent = (formatted: string): string => {
    if (typeof formatted !== 'string') {
        console.warn("truncateFormattedContent expected a string but received:", formatted);
        return '';
    }

    const trimmed = formatted.trim();
    const visibleLength = trimmed.replace(FORMATTING_CHARS_REGEX, '').length;

    if (visibleLength <= MAX_LENGTH) return trimmed;

    let visibleCount = 0;
    let result = '';

    for (const char of trimmed) {
        if (!FORMATTING_CHARS_REGEX.test(char)) {
            visibleCount++;
        }
        result += char;

        if (visibleCount >= MAX_LENGTH) {
            break;
        }
    }

    return result + '...';
};